import React from "react";
import axios from "axios";
import SglContext from "../SglContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./liveclass.css";

class LiveClassList extends React.Component {
  state = {
    live_now: [],
    upcoming: [],
    completed: [],
    raw_data: {},
    timeout: null,
    loading: true,
    userData: {},
    live_class_timer: null
  };

  constructor() {
    super();
  }

  componentDidMount() {
    this.getAllData();
  }

  componentWillUnmount() {
    
    // clear live timer 
    if (this.state.live_class_timer) {
      clearTimeout(this.state.live_class_timer);
      this.setState({ live_class_timer: null });
    }
    
  }

  getLiveClassData() {
    axios
      .get(
        this.context.sglApiUrl +
          "/iphonev2/index.php/" +
          this.context.company_urlpath +
          "/liveclassv2/ListAjax",
        {
          params: {
            from_wp_api: true,
          },
        }
      )
      .then((res) => {
        res.data = res.data[0];
        document.title = "Live Scoreboard for " + res.data.show_name;
        this.context.reportToGA(
          "/sgl-wp-plugin/" +
            this.context.company_urlpath +
            "/" +
            res.data.show_id +
            "/liveclass/list"
        );
        this.context.reportToFB(
          "/sgl-wp-plugin/" +
            this.context.company_urlpath +
            "/" +
            res.data.show_id +
            "/liveclass/list"
        );
        var live_now = [];
        var upcoming = [];
        var completed = [];

        for (var row of res.data.json_data) {
          switch (row.grid) {
            case "#LiveNow":
              live_now.push(row);
              break;
            case "#Upcoming":
              upcoming.push(row);
              break;
            case "#Completed":
              completed.push(row);
              break;
          }
        }

        this.setState({
          live_now: live_now,
          upcoming: upcoming,
          completed: completed,
          raw_data: res.data,
          loading: false,
        });
      });

    let live_class_timer = setTimeout(() => {
      this.getLiveClassData();
    }, 15 * 1000);
    this.setState({ live_class_timer: live_class_timer });
  }

  getAllData() {
    this.getUserData();
    this.getLiveClassData();
  }

  getUserData() {
    axios.get(this.context.nestApiUrl + "/users/getUser").then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
          });
        } else {
        }
      },
      (error) => {}
    );
  }

  render() {
    const loading = this.state.loading;

    if (loading) {
      return null;
    }

    return (
      <div className='section-to-print liveclasscss'>
        <section className='search-area'>
          <table>
            <tbody>
              <tr>
                <h2 className='sgl-h2'>
                  Live Scoreboard for {this.state.raw_data.show_name}
                </h2>
              </tr>
            </tbody>
          </table>
        </section>
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
        <br />
        <div className='div-responsive'>
          <table className='table table-striped table-hover table-responsive'>
            <thead>
              <tr className='sgl-primary-header'>
                <th colSpan='3'>LIVE NOW</th>
              </tr>
            </thead>
            <tbody>
              <tr className='sgl-secondary-header'>
                <th className='center-align'>Class</th>
                <th className='center-align'>Trips</th>
                <th className='center-align'>Ring</th>
              </tr>
              {this.state.live_now.map((data, index) => {
                return (
                  <tr
                    key={index}
                    onClick={() => {
                      // e.preventDefault();
                      const { navigate } = this.props;
                      navigate(
                        "/liveclass/detail?cid=" +
                          data.classes[0] +
                          "&class_group_id=" +
                          data.class_group_id +
                          "&sid=" +
                          this.state.raw_data.show_id
                      );
                    }}>
                    <td className='center-left'>
                      {data.group_name}
                      &nbsp; (
                      {data.classes.map((class_id, class_index) => {
                        return (
                          <Link
                            to={
                              "/liveclass/detail?cid=" +
                              class_id +
                              "&class_group_id=" +
                              data.class_group_id +
                              "&sid=" +
                              this.state.raw_data.show_id
                            }>
                            &nbsp;{data.classNumbers[class_index]}&nbsp;
                          </Link>
                        );
                      })}
                      )
                    </td>
                    <td className='center-align'>
                      {data.gone} / {data.total}
                    </td>
                    <td className='center-left'>{data.ring}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <br />
          <br />
          <table className='table table-striped table-hover table-responsive'>
            <thead>
              <tr className='sgl-primary-header'>
                <th colSpan='4'>UPCOMING</th>
              </tr>
            </thead>
            <tbody>
              <tr className='sgl-secondary-header'>
                <th className='center-align'>Class</th>
                <th className='center-align'>Trips</th>
                <th className='center-align'>Est. Start</th>
                <th className='center-align'>Ring</th>
              </tr>
              {this.state.upcoming.map((data, index) => {
                return (
                  <tr
                    key={index}
                    onClick={(e) => {
                      const { navigate } = this.props;
                      navigate(
                        "/liveclass/detail?cid=" +
                          data.classes[0] +
                          "&class_group_id=" +
                          data.class_group_id +
                          "&sid=" +
                          this.state.raw_data.show_id
                      );
                    }}>
                    <td className='center-left'>
                      {data.group_name}
                      &nbsp; (
                      {data.classes.map((class_id, class_index) => {
                        return (
                          <Link
                            to={
                              "/liveclass/detail?cid=" +
                              class_id +
                              "&class_group_id=" +
                              data.class_group_id +
                              "&sid=" +
                              this.state.raw_data.show_id
                            }>
                            &nbsp;{data.classNumbers[class_index]}&nbsp;
                          </Link>
                        );
                      })}
                      )
                    </td>
                    <td className='center-align'>{data.total}</td>
                    <td className='center-align'>{data.time}</td>
                    <td className='center-left'>{data.ring}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <br />
          <br />

          <table className='table table-striped table-hover table-responsive'>
            <thead>
              <tr className='sgl-primary-header'>
                <th colSpan='3'>COMPLETED</th>
              </tr>
            </thead>
            <tbody>
              <tr className='sgl-secondary-header'>
                <th className='center-align'>Class</th>
                <th className='center-align'>Trip</th>
                <th className='center-align'>Ring</th>
              </tr>
              {this.state.completed.map((data, index) => {
                return (
                  <tr
                    key={index}
                    onClick={(e) => {
                      const { navigate } = this.props;
                      navigate(
                        "/liveclass/detail?cid=" +
                          data.classes[0] +
                          "&class_group_id=" +
                          data.class_group_id +
                          "&sid=" +
                          this.state.raw_data.show_id
                      );
                    }}>
                    <td className='center-left'>
                      {data.group_name}
                      &nbsp; (
                      {data.classes.map((class_id, class_index) => {
                        return (
                          <Link
                            to={
                              "/liveclass/detail?cid=" +
                              class_id +
                              "&class_group_id=" +
                              data.class_group_id +
                              "&sid=" +
                              this.state.raw_data.show_id
                            }>
                            &nbsp;{data.classNumbers[class_index]}&nbsp;
                          </Link>
                        );
                      })}
                      )
                    </td>
                    <td className='center-align'>
                      {data.gone} / {data.total}
                    </td>
                    <td className='center-left'>{data.ring}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className='copyright-text'>
          {process.env.REACT_APP_COPYRIGHT_TEXT}
        </div>
      </div>
    );
  }
}

LiveClassList.contextType = SglContext;
export default function(props) {
  const navigate = useNavigate();

  return <LiveClassList {...props} navigate={navigate} />;
}


